/* eslint-disable prettier/prettier */
/* eslint-disable no-underscore-dangle */
import styled from 'styled-components';
import { gtmTriggerEvent } from 'lib/gtm';

const ItemLabel = styled.label`
  width: 95%;
  font-family: ‘Nunito Sans’, sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  cursor: pointer;
  margin-top: 16px;
  margin-bottom: 16px;
  @media only screen and (min-width: 600px) {
    transition: color 0.2s ease-in-out;
  }
`;

type Props = {
  id?: string;
  item: any,
  clickHandler: Function,
  image?: string,
  overImage?: string,
  children: any,
  ignoreHover?: boolean,
};

export const ItemType = {
  navegator: 0,
  link: 1,
};

const Img = styled.div((props: { type: any }) => ({
  display: props.type === ItemType.link ? 'none' : 'block',
  width: '24px',
  height: '24px',
  'object-fit': 'contain',
  'background-position': 'center',
  'background-repeat': 'no-repeat',
  'margin-right': '8px',
}));

const ListItem = (props: Props) => {
  const {
    id,
    item,
    clickHandler,
    image,
    overImage,
    children,
    ignoreHover,
  } = props;

  const Item = styled.div({
    height: 'auto',
    display: 'flex',
    color: '#6e0ad6',
    'align-items': 'center',
    'padding-left': children ? 0 : '24px',
    'align-itens': 'center',
    '.rigth-chevron': {
      'background-image': image,
    },
    cursor: ignoreHover ? 'default' : 'pointer',
    ':active': ignoreHover
      ? {}
      : {
          'background-color': '#6e0ad6',
          color: '#ffffff',
          '.rigth-chevron': {
            'background-image': overImage,
          },
        },
    '@media only screen and (min-width: 600px)': {
      height: '56px',
      transition:
        'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out',
      ':hover': ignoreHover
        ? {}
        : {
            'background-color': '#6e0ad6',
            color: '#ffffff',
            '.rigth-chevron': {
              'background-image': overImage,
            },
          },
    },
  });

  const handleClick = (e: any) => {
    gtmTriggerEvent('click_contact_us_list_item', {
      type: item?.__typename?.toLowerCase(),
      name: item?.name,
    });
    clickHandler(item, e);
  };

  return (
    <Item id={id} onClick={(e) => handleClick(e)}>
      {children || (
        <>
          <ItemLabel>{item.name}</ItemLabel>
          <Img className="rigth-chevron" type={item.type} />
        </>
      )}
    </Item>
  );
};

ListItem.defaultProps = {
  image: 'url(/images/chevron-right-gray.svg)',
  overImage: 'url(/images/chevron-right-white.svg)',
  ignoreHover: false,
  id: ''
};

export default ListItem;
